interface TailEdgeProps {
  className?: string;
}

/**
 * Shared technical top-edge signature for tail / closing sections.
 * Thin red hairline with a small chamfered block at the left.
 * Parent must be `relative`.
 */
export default function TailEdge({ className = '' }: TailEdgeProps) {
  return (
    <div aria-hidden="true" className={`pointer-events-none absolute inset-x-0 top-0 z-[1] h-[4px] ${className}`}>
      <span className="absolute inset-x-0 top-0 h-px bg-primary-500/55" />
      <span className="absolute left-0 top-0 h-[4px] w-[64px] md:w-[88px] bg-primary-500 [clip-path:polygon(0_0,100%_0,calc(100%-4px)_100%,0_100%)]" />
      <span className="absolute top-0 left-[72px] md:left-[96px] h-[4px] w-[10px] bg-primary-500/70 [clip-path:polygon(4px_0,100%_0,calc(100%-4px)_100%,0_100%)]" />
    </div>
  );
}